export default __webpack_public_path__ + "static/media/create-project.d5223a1f.svg";